import publicHttpClient from '@/services/http/publicHttpClient'
import httpClient from '@/services/http/httpClient'
import { getTokenStorage } from '@/infra/settings'

export const getToken = payload => {
  return publicHttpClient.post('api-token-auth/', payload)
}

export const getUser = () => {
  const headers = {
    'Authorization': `Token ${getTokenStorage()}`
  }
  return publicHttpClient.get('api-token-auth/user/', { headers })
}

export const apiPostUserLanguage = payload => {
  return httpClient.post('api-token-auth/language/', { lang: payload })
}

export const getTokenSso = (code, redirectUri) => {
  return publicHttpClient.post('api-token-auth/auth/', { code: code, redirect_uri: redirectUri })
}

export const getUserSso = () => {
  const headers = {
    'Authorization': `Token ${getTokenStorage()}`
  }
  return publicHttpClient.get('api-token-auth/usersso/', { headers })
}
